// extracted by mini-css-extract-plugin
export var text = "_bb-0";